export const setWebPageFavicon = (icon) => {
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
    }
    return (link.href = icon)
    // return (document.title = title);
}